export enum ActiveConnectionState {
        Disconnected = 0,
        Connecting = 1,
        Connected = 2,
        Error = 3
}
